// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"108":"451bc0380f993dd86b9a","293":"320b5f56eb7074aa3e29","452":"4d8b9db743ac4361608d"}[chunkId] + ".js";
};